import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlComponent } from '../base-control.component';

@Component({
  selector: 'boi-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CheckboxComponent,
      multi: true
    }
  ]
})
export class CheckboxComponent extends BaseControlComponent {
  @Input() public checkboxLabel = '';
  @Input() public trueValue: boolean | string = true;
  @Input() public falseValue: boolean | string = false;
  @Input() public isTooltipLast = true;

  public isChecked: boolean;

  public writeValue(value: any): void {
    super.writeValue(value);
    this.isChecked = this.value === this.trueValue;
  }

  updateCheckbox(): void {
    this.value = this.isChecked ? this.trueValue : this.falseValue;
  }
}
